import 'react-app-polyfill/ie11';
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { far as fontAwesomeRegular } from '@fortawesome/pro-regular-svg-icons';
import '@mlc/charlie-web-fonts';
import { LDContextProvider } from '@mlconline/react-launch-darkly';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createHashHistory } from 'history';
//@ts-ignore
import jQuery from 'jquery';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import 'whatwg-fetch';
import App from './App';
import './index.css';
import rootSaga from './logic/sagas/root.saga';
import './polyfill';
import registerServiceWorker from './registerServiceWorker';
import { adviserReducer } from './store/reducers/adviser.reducer/adviser.reducer';
import { locationReducer } from './store/reducers/location.reducer/location.reducer';
import { searchReducer } from './store/reducers/search.reducer/search.reducer';
import { recentClientsReducer } from './store/reducers/recent-clients.reducer/recent-clients.reducer';
import FetchConfig from './FetchConfig';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';

fontAwesomeLibrary.add(fontAwesomeRegular);

//@ts-ignore
window.$ = jQuery;
//@ts-ignore
window.jQuery = jQuery;

export const history = createHashHistory();
const sagaMiddleware = createSagaMiddleware();
const rootReducer = combineReducers({
	adviser: adviserReducer,
	router: connectRouter(history),
	search: searchReducer,
	location: locationReducer,
	recentClients: recentClientsReducer,
});

const reduxDevTools =
	(window as any)['__REDUX_DEVTOOLS_EXTENSION__'] &&
	(window as any)['__REDUX_DEVTOOLS_EXTENSION__']();

const store = (window as any)['__REDUX_DEVTOOLS_EXTENSION__']
	? createStore(
			rootReducer,
			compose(
				applyMiddleware(sagaMiddleware, routerMiddleware(history)),
				reduxDevTools
			)
	  )
	: createStore(
			rootReducer,
			compose(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
	  );

sagaMiddleware.run(rootSaga);

ReactDOM.render(
	<Provider store={store}>
		<FetchConfig>
			{(config: any) => {
				const ldConfig: any = {
					environmentKey: config.launchDarklyKey,
					user: {
						key: 'anon',
						anonymous: true,
					},
					defaultFlags: {
						'test-flag': false,
					},
				};

				const providerConfig: Auth0ProviderOptions = {
					domain: config.idp.customer.domain,
					clientId: config.idp.customer.clientId,
					audience: config.idp.customer.audience,
					redirectUri: config.idp.customer.callback
						? window.location.protocol +
						  '//' +
						  window.location.host +
						  config.idp.customer.callback +
						  encodeURIComponent(window.location.href)
						: encodeURIComponent(window.location.href),
				};
				return (
					<LDContextProvider config={ldConfig}>
						<Auth0Provider {...providerConfig}>
							<App />
						</Auth0Provider>
					</LDContextProvider>
				);
			}}
		</FetchConfig>
	</Provider>,
	document.getElementById('root') as HTMLElement
);
registerServiceWorker();

export type AppState = ReturnType<typeof rootReducer>;
